import React from 'react'
import { SelectSeeker } from "@ui-seeker/core"
import {featuresList, tableHideDetails} from "Pages/AnalyzersV2/@signals"
import { Box } from "@mui/material"

export default function AnalyzersFeaturesSelector() {

	return <Box data-tour-id="tour-features-selector" sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<SelectSeeker
			value={featuresList.value}
			onChange={e => featuresList.value = e.target.value}
			isClearable
			multiple
			sx={{ width: 220 }}
			label="Features"
			placeholder="Any feature"
			disabled={tableHideDetails.value}
			options={[
				{ value: "id_master_provider_translation|Provider", label: "Provider" },
				{ value: "car_description|Car Model", label: "Car Model" },
				{ value: "id_category|Category", label: "Category" },
				{ value: "acriss_code|Acriss", label: "Acriss" },
				{ value: "price|Price", label: "Price" },
				{ value: "automatic_translation|Transmission", label: "Transmission" },
				{ value: "id_fuel_policy_translation|Fuel Policy", label: "Fuel Policy" },
				{ value: "is_prepaid_translation|Payment", label: "Payment" },
				{ value: "pickup_date_translation|Pickup Date", label: "Pickup Date" },
				{ value: "position|Web Position", label: "Web Position" },
				{ value: "id_master_web_supplier_translation|Supplier", label: "Web Supplier" }
			]}
		/>
	</Box>
}
